import classNames from "classnames"
import AlertCircleOutline from "~icons/eva/alert-circle-outline"
import styles from "./styles.module.scss"

export const SelectItem = ({
  label,
  isActive,
  error,
  onClick,
}: {
  label: string
  isActive: boolean
  error?: string
  onClick?: () => void
}) => {
  return (
    <button
      className={classNames(styles.selectItem, isActive ? styles.activeItem : styles.inActiveItem)}
      onClick={onClick}
    >
      <div className={styles.innerContent}>
        <div className={styles.itemText}>
          <p className={styles.label}>{label}</p>
          {error && <p className={styles.errorText}>{error}</p>}
        </div>
        {error && <AlertCircleOutline className={styles.errorIcon} />}
      </div>
    </button>
  )
}
